import React from "react";
import PropTypes from 'prop-types';
import { withRouter } from 'react-router-dom';
import { CommonButtonPopup } from "../ReportsV2/styles";
import { PointText, StyledModal } from "../../components/RewardsManagement/Rewards/styles"
import { commaSeperator, fetchApi } from "../../utils/methods";
import { DismissSpotPointNotify } from "../../redux/constants/apiConstants";
import { toast } from "react-toastify";
import { getUser } from "../../redux/actions";
import { useDispatch } from "react-redux";


const CongratulationPopup = ({
  show,
  modalWidth = "400px",
  modalHeight = "auto",
  // companyInfo,
  onCancel,
  SpotPointsEarned,
  UserName,
  SpotPointsDescription,
  //   history,
}) =>{

  //   const [loading, setLoading] = useState(false);
  

  const dispatch = useDispatch();


  const DissMissSpotPointPopup = async () => {
    try {
      const url = DismissSpotPointNotify;
      const res = await fetchApi(url, "PUT");
      if (res.status === "success") {
        toast.success(res.data.message);
        onCancel()
        dispatch(getUser());
        // this.setState({ showCongratsOverlay: false });
      } else {
        toast.error(res.error);
      }
    } catch (error) {
      window.console.error(error);
    }
  };
  
    
  return(
    <StyledModal show={show} width={modalWidth} height={modalHeight} style={{zIndex:9999}}  >
      <div className="headingText">
         Congratulations {UserName}!
      </div>
      <PointText isMargin={"20px"}>You Received +{commaSeperator(SpotPointsEarned)} Spot Points From Your Organization for your great work Keep it up! </PointText>
      <PointText>{SpotPointsDescription}</PointText>
      <div className='footer'>
        <CommonButtonPopup height="44px" width="341px"  onClick={DissMissSpotPointPopup}>
         Thank You!
        </CommonButtonPopup>
      </div>
    </StyledModal>
  )};


CongratulationPopup.propTypes = {
  show: PropTypes.bool.isRequired,
  SpotPointsDescription: PropTypes.string,
  modalWidth: PropTypes.string,
  modalHeight: PropTypes.string,
  history:PropTypes.object,
  companyInfo:PropTypes.object,
  onCancel: PropTypes.func,
  SpotPointsEarned: PropTypes.number,
  UserName: PropTypes.string,
};

export default withRouter((CongratulationPopup));
  
